import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check } from "lucide-react";

export const CoverPicker = ({ open, onOpenChange, current, onPick }) => {
  const [covers, setCovers] = useState([]);

  useEffect(() => {
    if (!open || covers.length) return;
    api.get("/admin/insight-drafts/stock-covers").then(({ data }) => setCovers(data.covers || [])).catch(() => {});
  }, [open, covers.length]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto" data-testid="cover-picker-dialog">
        <DialogHeader>
          <DialogTitle>Choose a stock photo</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-2">
          {covers.map((c) => {
            const selected = c.url === current;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => { onPick(c.url); onOpenChange(false); }}
                className={`group text-left rounded-xl overflow-hidden border-2 transition-colors ${selected ? "border-[#ac62ea]" : "border-transparent hover:border-[#ac62ea]/50"}`}
                data-testid={`cover-picker-option-${c.id}`}
              >
                <div className="relative aspect-[3/2] bg-muted">
                  <img src={c.url.replace("w=1600", "w=480")} alt={c.label} loading="lazy" className="w-full h-full object-cover" />
                  {selected && (
                    <span className="absolute top-2 right-2 rounded-full bg-[#ac62ea] text-white p-1"><Check className="h-3.5 w-3.5" /></span>
                  )}
                  {c.in_use && !selected && (
                    <span className="absolute top-2 left-2 rounded-full bg-black/60 text-white text-[10px] px-2 py-0.5">Used on a post</span>
                  )}
                </div>
                <div className="px-2 py-2 text-xs text-foreground/70">{c.label}</div>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};
